<svelte:head>
  <title>Offer pending end | A Good Thing</title>
</svelte:head>

<section class="section hero">
  <div class="hero-body">
    <div class="container">
      <div class="columns is-centered">
        <div class="card">
          <div class="card-header">
            <p class="card-header-title">
              <!-- svelte-ignore a11y-missing-attribute -->
              <a href="https://www.agoodthing.org.uk/">
                <img src="/assets/img/logo_h.png" />
              </a>
            </p>
          </div>
          <div class="card px-4 py-5">
            <div class="title">Thank you for letting us know</div>
            {#if keepLive}
            <div class="subtitle mt-1">
              We will keep the offer live.
            </div>
            {:else}
            <div class="subtitle mt-1">
              We will automatically pause the offer in 48 hours.
            </div>
            {/if}
            <hr />
            <div class="block">
              <a href={"/business/offer/" + offerId}>View and manage offer</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<script lang="ts">

  import { url, params } from "@sveltech/routify";

  const keepLive = $params.keeplive === 'yes' ? true : false;
  const offerId = $params.offerId;
  const firebase = window.firebase;
  
  if(keepLive) {
    removeTag();
  }

  async function removeTag() {
    await firebase.functions().httpsCallable('api-offer-removeoffertag')({
      offerId,
      tag: 'pending-auto-end'
    } as RemoveOfferTagParams);
  }

</script>